const Medication = ({ name, dates }) => {
  return (
    <div className="row">
      <span className="col">{name}</span>
      <span className="col">{dates.join("-")}</span>
    </div>
  );
};

export default Medication;
